import React from "react";
import DynamicFieldConfigType from "../types/DynamicFieldConfigType";
import DynamicFieldLabel from "./DynamicFieldLabel";
import { useDynamicFormRenderer } from "../context/dynamicFormRendererContext";
import FormMultiFileUploadField from "../../fields/multiFileUploadField";
import { AssetType } from "../../../enums/AssetType";
import { AssetUploadType } from "../../core/assetUpload/types";

/**
 * @name PrivateMultiFileFieldWrapper
 * @interface DynamicFieldConfigType
 * @param props
 * @constructor
 */

export default function PrivateMultiFileFieldWrapper(props: DynamicFieldConfigType) {
  const { registrationId, registrationParticipantId } = useDynamicFormRenderer();
  return (
    <React.Fragment>
      <FormMultiFileUploadField
        name={props.schemaObj.id}
        assetType={AssetType.PRIVATE_USER_INPUT}
        assetUploadType={AssetUploadType.BOTH}
        label={<DynamicFieldLabel schemaObj={props.schemaObj} />}
        disabled={props.schemaObj.disabled}
        required={props.schemaObj.mandatory}
        validate={props.validationFn}
        placeholder={props.schemaObj.placeholderLabel}
        registrationId={registrationId as string}
        fullWidth={true}
        indented={props.schemaObj.indented}
        registrationParticipantId={registrationParticipantId}
        min={props.schemaObj.minimum}
        max={props.schemaObj.maximum}
        disableImagePreview={true}
      />
    </React.Fragment>
  );
}
